/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiXTdhGrantTargetChain } from '../models/ApiXTdhGrantTargetChain';
import { HttpFile } from '../http/http';

export class ApiXTdhCreateGrant {
    'target_chain': ApiXTdhGrantTargetChain;
    'target_contract': string;
    /**
    * List of token numbers. Each element can also be a span in form of start-end. Leave empty if all tokens are targets.
    */
    'target_tokens': Array<string>;
    'valid_to': number | null;
    'rate': number;
    /**
    * If true then the grant must be covered with lock contracts
    */
    'is_irrevocable': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "target_chain",
            "baseName": "target_chain",
            "type": "ApiXTdhGrantTargetChain",
            "format": ""
        },
        {
            "name": "target_contract",
            "baseName": "target_contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "target_tokens",
            "baseName": "target_tokens",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "valid_to",
            "baseName": "valid_to",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rate",
            "baseName": "rate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "is_irrevocable",
            "baseName": "is_irrevocable",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiXTdhCreateGrant.attributeTypeMap;
    }

    public constructor() {
    }
}


